import { Link } from "react-router-dom";
import { Camera } from "lucide-react";
import PageHeader from "@/components/PageHeader";
import Reveal from "@/components/Reveal";
import { COACHES } from "@/data/content";

export default function Coaches() {
  return (
    <>
      <PageHeader
        eyebrow="The Sideline"
        title="Meet The Coaches"
        description="Ducks coaches are mentors first — developing athletes on the field and young people off it."
        testid="coaches-header"
      />
      <section className="pt-6 pb-14 sm:pb-20 bg-[#0A0A0A]" data-testid="coaches-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-testid="coaches-grid">
            {COACHES.map((coach, i) => (
              <Reveal key={coach.name || coach.role} delay={(i % 2) * 0.1}>
                <div
                  className="group flex items-center gap-6 bg-[#111111] border border-[#FEE123]/40 p-8 transition-all duration-300 hover:-translate-y-1 hover:border-[#FEE123]/60"
                  data-testid={`coach-card-${i}`}
                >
                  <div
                    className="w-24 h-24 shrink-0 flex flex-col items-center justify-center border-2 border-dashed border-[#FEE123]/40 bg-[#0A0A0A] rounded-sm"
                    data-testid={`coach-photo-slot-${i}`}
                  >
                    <Camera size={22} className="text-[#FEE123]/50" />
                    <span className="mt-1 text-[9px] uppercase tracking-widest text-gray-500">Photo Soon</span>
                  </div>
                  <div>
                    <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#FEE123]">{coach.role}</p>
                    <h3 className="mt-2 text-2xl font-bold uppercase tracking-wide text-white">
                      {coach.name || coach.role}
                    </h3>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.2}>
            <div className="mt-10 bg-[#06220F] border border-[#333333] p-8 sm:p-10 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-6" data-testid="coaches-volunteer-cta">
              <div>
                <h3 className="font-display text-3xl uppercase text-white">Want To Coach Or Volunteer?</h3>
                <p className="mt-2 text-sm text-gray-300">We're always looking for mentors who believe in the mission.</p>
              </div>
              <Link
                to="/join"
                data-testid="coaches-volunteer-button"
                className="shrink-0 inline-flex items-center justify-center bg-[#FEE123] text-black text-base font-extrabold uppercase tracking-widest px-7 py-3 rounded-sm transition-transform duration-200 hover:scale-105 hover:bg-[#FFEA61]"
              >
                Get In Touch
              </Link>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
